// extracted by mini-css-extract-plugin
export var cardIcon = "_16-5";
export var cardIconUnframed = "_16-9";
export var checkboxCard = "_16-0";
export var checkboxCardSelected = "_16-4";
export var disabled = "_16-2";
export var interactive = "_16-1";
export var outerBorder = "_16-3";
export var spacerMedium = "_16-8";
export var spacerSmall = "_16-7";
export var spacerXsmall = "_16-6";